import { ROOM_STATUS } from 'constants/index';
import Pubnub from 'pubnub';
import { ClientRoomData } from 'models/room/interface';

type NonRequiredField<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export enum MessageType {
  RAISE_HAND = 'raise_hand',
  REACTION = 'reaction',
  BLOCK = 'block',
}

export type RaiseHandMessage = {
  id: string;
  name: string;
  messageTimeToken: string | number;
  alreadySpeakTotal: string | number;
};

export type PubnubMsgsItem = NonRequiredField<Pubnub.FetchMessagesResponse['channels']['string'][0], 'actions'>;

export type ChannelMetaDataCustom = {
  listenersAllowedToSpeak: string; // Array<{ id: string; name: string }>
};

export type SystemChannelMetaDataCustom = Pick<ClientRoomData, 'startedAt'> & {
  isBroadcasting: boolean;
  roomStatus: ROOM_STATUS;
};

export type UserCustom = { blocked?: string; alreadySpeakTotal: string | number };
export type ParsedPubnubMessage = { name: string; id: string; type: MessageType; alreadySpeakTotal: string | number };
export type UserMetadata = Pubnub.UUIDMetadataObject<UserCustom>;
